import { useState } from 'react';

export function useRevealErrors(showAll: boolean) {
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  const touch = (key: string) =>
    setTouched((t) => (t[key] ? t : { ...t, [key]: true }));
  const reveal = (key: string) => showAll || !!touched[key];
  return { touch, reveal };
}
